/**
 * Composable for working with catalog text lists
 * Converts catalogTextListMixin.vue to a TypeScript composable
 */

export interface TextListItem {
  Key?: string | null;
  AttributeKey?: string | null;
  Value?: string | null;
}

export const useCatalogTextList = () => {
  /**
   * Find and return a value from a text list by key
   * @param textList - Array of text list items
   * @param key - The key to search for (matches either Key or AttributeKey)
   * @returns The value associated with the key, or null if not found
   */
  const textListValue = (
    textList: TextListItem[] | null | undefined,
    key: string,
  ): string | null => {
    if (!textList) {
      return null;
    }

    const item = textList.find(
      (textListItem) => textListItem.Key === key || textListItem.AttributeKey === key,
    );

    return item?.Value ?? null;
  };

  return {
    textListValue,
  };
};
